<template>
    <or-layout>
        <a-row :gutter="[16, 16]" type="flex" justify="space-between">
            <a-col :span="5">
            </a-col>
            <a-col>
                <a-form layout="inline">
                    <a-form-item>
                        <a-select v-model="searchFrom.subject" placeholder="学科" style="width: 120px;">
                            <a-select-option :value="1">数学</a-select-option>
                            <a-select-option :value="2">英语</a-select-option>
                            <a-select-option :value="3">语文</a-select-option>
                            <a-select-option :value="4">化学</a-select-option>
                            <a-select-option :value="5">物理</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.campus_id" placeholder="校区" style="width: 150px;" allow-clear>
                            <a-select-option v-for="item in campusList" :key="item.id" :value="item.id">{{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.grade_id" placeholder="年级" style="width: 220px;" allow-clear>
                            <a-select-option v-for="(item) in gradeList" :key="item.id" :value="item.id">{{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.opening" placeholder="开班状态" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">未开班</a-select-option>
                            <a-select-option :key="1" :value="1">已开班</a-select-option>
                            <a-select-option :key="2" :value="2">已结班</a-select-option>
                        </a-select>
                    </a-form-item>


                    <a-form-item>
                        <a-select v-model="searchFrom.status" placeholder="班级状态" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">禁用</a-select-option>
                            <a-select-option :key="1" :value="1">可用</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select v-model="searchFrom.semester_name" placeholder="季度" allow-clear style="width: 80px;">
                            <a-select-option :key="-1" value="">全部</a-select-option>
                            <a-select-option :key="0" value="寒假">寒假</a-select-option>
                            <a-select-option :key="1" value="春季">春季</a-select-option>
                            <a-select-option :key="2" value="暑假">暑假</a-select-option>
                            <a-select-option :key="3" value="秋季">秋季</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select v-model="searchFrom.year_name" placeholder="年度" allow-clear style="width: 80px;">
                            <a-select-option :key="-1" value="">全部</a-select-option>
							<a-select-option :key="5" value="2026">2026年</a-select-option>
							<a-select-option :key="5" value="2025">2025年</a-select-option>
							<a-select-option :key="4" value="2024">2024年</a-select-option>
                            <a-select-option :key="3" value="2023">2023年</a-select-option>
                            <a-select-option :key="0" value="2021">2021年</a-select-option>
                            <a-select-option :key="2" value="2022">2022年</a-select-option>
                            <a-select-option :key="1" value="2020">2020年</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.type" placeholder="班型" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">培优</a-select-option>
                            <a-select-option :key="1" :value="1">提高</a-select-option>
                            <a-select-option :key="2" :value="2">英才</a-select-option>
                            <a-select-option :key="3" :value="3">1对1VIP班</a-select-option>
							 <a-select-option :key="4" :value="4">体验课</a-select-option>
							  <a-select-option :key="5" :value="5">冲刺班</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select v-model="searchFrom.order" placeholder="排序" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">不排序</a-select-option>
                            <a-select-option :key="1" :value="1">总数正序</a-select-option>
                            <a-select-option :key="2" :value="2">总数反序</a-select-option>
                            <a-select-option :key="3" :value="3">参测人数正序</a-select-option>
                            <a-select-option :key="4" :value="4">参测人数反序</a-select-option>

                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-input placeholder="班级名称" v-model="searchFrom.keyword" @keyup.enter="tableSearch"></a-input>
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" htmlType="submit" icon="search" @click="tableSearch"></a-button>
                    </a-form-item>
                </a-form>
            </a-col>
        </a-row>
        <a-divider></a-divider>
        <div>
            <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="表格">
                    <a-table :dataSource="tabledata" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
                        @change="onPaginationChange" bordered>
                        <a-table-column key="gradename" title="年级" data-index="gradename" />
                        <a-table-column key="name" title="班级" data-index="name" />
                        <a-table-column key="campusname" title="校区" data-index="campusname" />
                        <!--  <a-table-column key="coursename" title="课程包" data-index="coursename"/> -->
                        <!-- <a-table-column key="amount" title="计划人数" data-index="amount"/> -->
                        <a-table-column key="actual" title="实际人数" data-index="actual" />
                        <a-table-column key="statistic" title="正常参测" data-index="statistic" />
                        <!--  <a-table-column key="code" title="班级码" data-index="code"/> -->
                        <a-table-column key="banzhuren" title="班主任" data-index="banzhuren" />
                        <a-table-column key="teacher" title="任课老师" data-index="teacher" />
                        <a-table-column key="interval" title="时间">
                            <template slot-scope="item">
                                <span v-if="item.interval == 1">每周六</span>
                                <span v-if="item.interval == 2">每周天</span>
                                <span v-if="item.interval == 3">每天</span>
                                <span v-if="item.phase == 1">第一阶段</span>
                                <span v-if="item.phase == 2">第二阶段</span>
                                <span v-if="item.phase == 3">第三阶段</span>
                                <span v-if="item.phase == 4">第四阶段</span>
								  <span v-if="item.phase == 5">第四阶段</span>
                            </template>
                        </a-table-column>
                        <a-table-column key="type" title="班型">
                            <template slot-scope="item">
                                <span v-if="item.type == 0">培优班</span>
                                <span v-if="item.type == 1">提高班</span>
                                <span v-if="item.type == 2">英才班</span>
                                <span v-if="item.type == 3">1对1VIP班</span>
								<span v-if="item.type == 4">体验课</span>
								<span v-if="item.type == 5">冲刺班</span>
                            </template>
                        </a-table-column>
                        <!-- <a-table-column key="opening" title="开班状态">
                        <template slot-scope="item">
                            <span v-if="item.opening==0">未开班</span>
                            <span v-if="item.opening==1">已开班</span>
                            <span v-if="item.opening==2">已结班</span>
                        </template>
                    </a-table-column> -->
                        <a-table-column key="status" width="100px;" title="状态">
                            <template slot-scope="item">
                                <span v-if="item.status == 1">可用</span>
                                <span v-if="item.status == 0">已禁用</span>
                            </template>
                        </a-table-column>
                        <!--   <a-table-column key="active" width="280px" title="操作">
                        <template slot-scope="item">
                            <a-button
                                    v-if="item.status==0"
                                    @click="changeStatus({id:item.id,status:1,pid:item.pid})"
                                    class="active_btn"
                                    size="small"
                                    type="link"
                            >启用
                            </a-button>
                            <a-button
                                    v-if="item.status==1"
                                    @click="changeStatus({id:item.id,status:0,pid:item.pid})"
                                    class="active_btn"
                                    size="small"
                                    type="link"
                            >禁用
                            </a-button>
                            <a-button
                                    v-if="item.status==1"
                                    @click="tableEdit(item)"
                                    class="active_btn"
                                    size="small"
                                    type="link"
                            >编辑
                            </a-button>
                            <router-link :to="{path:'/orgquadinfo',query:{id:item.id}}">查看详情</router-link>
                            <a-dropdown :trigger="['click']" v-if="item.status==1">
                                <a-button size="small" type="link" icon="more"/>
                                <a-menu slot="overlay">
                                    <a-menu-item>
                                        <a href="javascript:;" @click="tableDel({ids:item.id})">删除</a>
                                    </a-menu-item>
                                </a-menu>
                            </a-dropdown>
                        </template>
                    </a-table-column> -->
                    </a-table>
                </a-tab-pane>

                <a-tab-pane key="2" tab="图表" force-render>
                    <v-chart :forceFit="true" :height="400" :data="piedata" :scale="scale">
                        <v-tooltip :showTitle="false" dataKey="item*percent" />
                        <v-axis />
                        <v-legend dataKey="item" />
                        <v-pie position="percent" color="item" :v-style="pieStyle" :label="labelConfig" />
                        <v-coord type="theta" />
                    </v-chart>

                    <a-divider></a-divider>
                    <v-chart :forceFit="true" :padding="padding" :height="heightx" :data="xx">
                        <v-coord type="rect" direction="LB" />
                        <v-tooltip />
                        <v-legend />
                        <v-axis dataKey="label" label="name" />
                        <v-axis dataKey="label" position="right" />
                        <v-stack-bar position="name*value" color="type" />
                    </v-chart>
                </a-tab-pane>
            </a-tabs>



        </div>


    </or-layout>
</template>

<script>
import AFormItem from "ant-design-vue/es/form/FormItem";
const DataSet = require('@antv/data-set');
const scale = [{
    dataKey: 'percent',
    min: 0,
    formatter: '.0%',
}];
export default {
    components: {
        AFormItem
    },

    data() {
        return {
            tabledata: [],
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 9999
            },
            scale,
            padding: [20, 80, 50, 200],
            loading: false,
            courseList: [],
            pieStyle: {
                stroke: "#fff",
                lineWidth: 1
            },
            searchFrom: {
                keyword: undefined,
                grade_id: undefined,
                campus_id: undefined,
                type: undefined,
                opening: 1,
                status: 1,
                semester_name: '寒假',
                year_name: '2021'

            },
            sourceData: [{
                'name': 'WY',
                'amout': 25635,
                'actual': 1890,
                'statistic': 9314
            }

            ],
            labelConfig: ['count', {
                formatter: (val, item) => {
                    return item.point.item + ': ' + val;
                }
            }],
            dataviser: [],
            height: 100,
            label: {
                offset: 12
            },
            campusList: [],
            gradeList: [],
            campuscount: [],
        };
    },
    mounted() {
        this.getCampusList();
        this.getGradeList();
    },
    computed: {
        xx() {
            //  let me = this 
            const sourceData = [];
            this.tabledata.forEach(row => {
                row['name'] = row['gradename'] + row['campusname'] + row['name'];
                row['不参测人数'] = Number(row['actual'] - row['statistic']);
                row['参测人数'] = Number(row['statistic']);
                sourceData.push(row);
            });
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
                type: 'fold',
                fields: ['参测人数', '不参测人数'],
                key: 'type',
                value: 'value',
                retains: ['name', 'campusname'],
            });
            const dataviser = dv.rows;
            return dataviser;
        },

        piedata() {
            /* this.campuscount;
             const sourceData = [
                 { item: '事例一', count: 40 },
                 { item: '事例二', count: 21 },
                 { item: '事例三', count: 17 },
                 { item: '事例四', count: 13 },
                 { item: '事例五', count: 9 }
               ]; */

            const sourceData = [];
            this.campuscount.forEach(row => {
                row['count'] = Number(row['count']);
                sourceData.push(row);
            });

            const dv = new DataSet.View().source(sourceData);
            dv.transform({
                type: 'percent',
                field: 'count',
                dimension: 'item',
                as: 'percent'
            });
            return dv.rows;
        },
        heightx() {
            return this.tabledata.length * 50;
        }

    },

    methods: {
        changeFormCampus(campus_id) {
            this.getCourseTeacherList({
                campus_id: campus_id
            });
        },
        getGradeList() {
            this.$axios
                .post("/api/BasicGrade/index")
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.gradeList = res.data.data;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        getCourseList() {
            this.$axios
                .post("/api/BasicCourse/index", {
                    pageinfo: {
                        pageSize: 9999
                    }
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.courseList = res.data.data;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        getCampusList() {
            this.$axios
                .post("/api/admin/getmycampuslist")
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.campusList = res.data;
                        this.tableSearch();
                        // this.getCourseList();
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        changeCampus(e) {
            this.searchForm.campus_id = e;
        },
        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.getTableList(this.searchFrom);
        },
        tableSearch() {
            this.pageinfo.current = 1;
            this.getTableList(this.searchFrom);
        },
        getTableList(data) {
            this.loading = true;
            this.$axios
                .post("/api/OrgSquad/index", {
                    data,
                    pageinfo: this.pageinfo
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.campuscount = res.data.campus;
                        this.tabledata = res.data.data;
                        this.pageinfo = res.data.pageinfo;
                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })
        }
    }
};
</script>
<style>
.active_btn {
    margin-left: 5px;
}
</style>
